import { transform } from 'ol/proj.js';

export default function reprojectionCoordinates(coordinates, from, to) {
    var coordinatesToChange = [...coordinates];
    var result = [];
    if (from == to) {
        result = coordinatesToChange;
    } else {
        coordinatesToChange.forEach((coordinate, ind) => {
            if (coordinate.length > 2) {
                var new_coordinate = [];
                for (var i = 0; i < coordinate.length / 2; i++) {
                    var new_coord = new transform([coordinate[i * 2], coordinate[i * 2 + 1]], from, to);
                    new_coordinate[i * 2] = new_coord[0];
                    new_coordinate[i * 2 + 1] = new_coord[1];
                }
                result[ind] = new_coordinate;
            } else if (coordinate.length == 2) {
                result[ind] = new transform(coordinate, from, to);
            }
        });
    }
    return result;
}
